let enabled = false;

export const isEngagementContractDateValidationEnabled = () => enabled;

export const setEngagementContractDateValidation = (value: boolean) => {
  enabled = value;
};
